import PropTypes from 'prop-types';
import * as Styled from './Price.styles';
import { Stack } from '@mui/material';

export const Price = ({ price, subPrice }) => {
  return (
    <Styled.Stack direction="row" >
        <Styled.Price>
            {price}
        </Styled.Price>
        <Styled.SubPrice>
            {subPrice}
        </Styled.SubPrice>
        <Stack direction="row" justifyContent='flex-end' alignItems="flex-end" >
          <Styled.PeriodDivider>
           /
          </Styled.PeriodDivider>
          <Styled.Period>
           miesięcznie
          </Styled.Period>
        </Stack>     
    </Styled.Stack> 
  );
};

Price.propTypes = {
    price: PropTypes.string,
    subPrice: PropTypes.string   
};
